import Titulo from '@/components/tipografia/Titulo';
import React, { useCallback } from 'react';
import styles from './page.module.css';
import LayoutUsuario from '@/components/navegacao/LayoutUsuario';
import Descricao from '@/components/tipografia/Descricao';
import HBox from '@/components/layout/HBox';
import Botao from '@/components/Botao';
import VBox from '@/components/layout/VBox';
import CampoTexto from '@/components/Formulario/CampoTexto';
import Icon from '@mdi/react';
import {
  mdiArrowDown,
  mdiArrowUp,
  mdiLoading,
  mdiMagnify,
  mdiPen,
  mdiPlus,
  mdiTrashCan,
} from '@mdi/js';
import DataTable, { DataTableHeader } from '@/components/layout/DataTable';
import { useInfiniteQuery, useMutation } from 'react-query';
import axios from 'axios';
import { useDebounce } from '../chat/useDebounce';
import Modal from '@/components/layout/Modal';
import { toast } from 'react-toastify';
import BotaoPerigoso from '@/components/BotaoPerigoso';
import CampoSeletor from '@/components/Formulario/CampoSeletor';
import CampoCheckbox from '@/components/Formulario/CampoCheckbox';
import { useAuth } from '@/lib/useAuth';
import {
  hasAuthorization,
  rolesAdmin,
  rolesManager,
} from '@tera/shared/src/lib/auth';
import { FormChatMensagemAtalho } from './FormChatMensagemAtalho';
import Grid, { GridItem } from '@/components/layout/Grid';

type PageProps = {};

type ResponseList = {
  status: number;
  ok?: boolean;
  result: any[];
  total: number;
  cursor: string | number | null;
};

const Page = ({ }: PageProps) => {
  const { user } = useAuth();

  const [editObject, setEditObject] = React.useState<any>(null);
  const [fieldErrors, setFieldErrors] = React.useState<Record<
    string,
    string
  > | null>(null);

  const [search, setSearch] = React.useState<string>('');
  const debouncedSearch = useDebounce(search, 500);

  const headers: DataTableHeader[] = [
    {
      label: 'Nome',
      width: '50%',
      render: (row: any) => {
        return (
          <span title={row.conteudo}>
            {row.favorito ? '⭐ ' : ''}
            {row.atalho}
          </span>
        );
      },
    },
    {
      label: 'Visibilidade',
      width: '50%',
      render: (row: any) => {
        return row.global
          ? 'Global'
          : row.usuario_id > 0
            ? (row.usuario_id === user.id ? 'Pessoal (você)' : 'Pessoal (outro)')
            : row.usuario_grupo_id > 0
              ? 'Grupo'
              : '(Desconhecido)';
      },
    },
    { label: 'Posição', width: '50%', column: 'indice' },
    {
      label: 'Ações',
      width: '100px',
      stickRight: true,
      alignRight: true,
      render: (row: any) => {
        const list =
          queryList.data?.pages
            ?.map(p => p.data.result)
            ?.flat()
            ?.filter(it => !!it.global === !!row.global) ?? [];

        console.log('canEdit check', { row, user, rowGlobal: row.global, papel: user.papel, userId: user.id })

        const canEdit =
          !chgIndice.isLoading &&
          ((row.global && hasAuthorization(user, rolesAdmin)) ||
            (!row.global &&
              hasAuthorization(user, rolesManager) &&
              row.usuario_grupo_id === user.grupo_id) ||
            (!row.global && row.usuario_id === user.id));
        return (
          <HBox gap="8px" style={{ justifyContent: 'flex-end' }}>
            <div style={{ width: '24px' }}>
              {row.indice < list.length && (
                <Botao
                  disabled={!canEdit}
                  variant="none-info"
                  icon={mdiArrowDown}
                  title="Mover para baixo"
                  onClick={() =>
                    chgIndice.mutate({ id: row.id, newIdx: row.indice + 1 })
                  }
                ></Botao>
              )}
            </div>
            <div style={{ width: '24px' }}>
              {row.indice > 1 && (
                <Botao
                  disabled={!canEdit}
                  variant="none-info"
                  icon={mdiArrowUp}
                  title="Mover para cima"
                  onClick={() =>
                    chgIndice.mutate({ id: row.id, newIdx: row.indice - 1 })
                  }
                ></Botao>
              )}
            </div>

            <Botao
              variant="none-primary"
              disabled={!canEdit}
              icon={mdiPen}
              title="Editar"
              onClick={() => setEditObject(row as any)}
            ></Botao>

            <BotaoPerigoso
              variant="none-danger"
              disabled={!canEdit}
              icon={mdiTrashCan}
              title="Apagar"
              onClick={() => handleDelete(row.id)}
            />
          </HBox>
        );
      },
    },
  ];

  const chgIndice = useMutation(
    async ({ id, newIdx }: { id: number; newIdx: number }) => {
      const result = await axios.put(
        `/api/chat_mensagem_atalho/${id}/indice/${newIdx}`,
        {},
        {
          withCredentials: true,
        },
      );
      return result.data;
    },
    {
      onSuccess: () => {
        toast('Índice atualizado com sucesso', {
          toastId: 'success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
        queryList.refetch();
      },
      onError: (err: any) => {
        toast('Ocorreu um erro ao tentar atualizar o índice.', {
          toastId: 'error',
          position: 'top-center',
          type: 'warning',
          autoClose: 5000,
        });
      },
    },
  );

  const queryList = useInfiniteQuery({
    queryKey: ['chat_mensagem_atalho', debouncedSearch],
    queryFn: async ({ pageParam }) => {
      const params = new URLSearchParams({
        txt: debouncedSearch,
        c: pageParam,
      });

      return await axios.get<ResponseList>(
        `/api/chat_mensagem_atalho?${params.toString()}`,
        {
          withCredentials: true,
        },
      );
    },
    getNextPageParam: lastPage => lastPage.data.cursor ?? undefined,
  });

  const changeMutator = useMutation(
    async () => {
      if (!editObject) return;

      setFieldErrors(null);
      if (editObject.id) {
        return await axios.put(
          `/api/chat_mensagem_atalho/${editObject.id}`,
          editObject,
          {
            withCredentials: true,
          },
        );
      } else {
        return await axios.post(`/api/chat_mensagem_atalho`, editObject, {
          withCredentials: true,
        });
      }
    },
    {
      onSuccess: () => {
        setFieldErrors(null);
        queryList.refetch();
        setEditObject(null);
      },
      onError: (err: any) => {
        if (err.response?.status === 422) {
          setFieldErrors(err.response?.data?.fieldErrors ?? {});
        }
        toast(err.response?.data?.msg ?? 'Erro desconhecido', {
          toastId: 'error',
          position: 'top-center',
          type: 'warning',
          autoClose: 5000,
        });
      },
    },
  );

  const deleteMutator = useMutation(
    async (id: number) => {
      return await axios.delete(`/api/chat_mensagem_atalho/${id}`, {
        withCredentials: true,
      });
    },
    {
      onSuccess: () => {
        toast('Atalho apagado com sucesso', {
          toastId: 'success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
        queryList.refetch();
      },
      onError: (err: any) => {
        console.error(err);
        toast('Ocorreu um erro ao tentar apagar o atalho.', {
          toastId: 'error',
          position: 'top-center',
          type: 'warning',
          autoClose: 5000,
        });
      },
      onSettled: () => {
        queryList.refetch();
      },
    },
  );

  const handleChange = useCallback(async () => {
    await changeMutator.mutate();
  }, [changeMutator]);

  const handleDelete = (id: number) => {
    deleteMutator.mutate(id);
  };

  const queryFlatList =
    queryList.data?.pages?.map(p => p.data.result)?.flat() ?? [];
  const total =
    queryList.data?.pages?.[queryList.data.pages.length - 1]?.data?.total ?? 0;

  const editMode = !!editObject?.id && editObject.id > 0;

  const handleCloseModal = () => {
    setEditObject(null);
    setFieldErrors(null);
  };

  const handleOpenModalNewObject = () => {
    setEditObject({});
  };

  return (
    <LayoutUsuario>
      <Modal
        ignoreOverlayClick
        size="lg"
        title={editMode ? 'Editar atalho' : 'Novo atalho'}
        show={!!editObject}
        onClose={handleCloseModal}
        onCancel={handleCloseModal}
        onConfirm={handleChange}
      >
        <FormChatMensagemAtalho
          list={queryFlatList}
          value={editObject as any}
          onChange={setEditObject}
          fieldErrors={fieldErrors}
        />
      </Modal>
      <VBox gap="16px" style={{ height: 'calc(100vh - 32px)' }}>
        {/* Header */}
        <Grid>
          <GridItem sm={12} lg={6}>
            <VBox>
              <Titulo>Atalhos de mensagem</Titulo>
              <Descricao>
                Gerencie aqui os atalhos das mensagens de chat. Os atendentes
                podem utilizar os atalhos para agilizar a resposta aos clientes.
              </Descricao>
            </VBox>
          </GridItem>
          <GridItem sm={12} lg={6}>
            <HBox gap="12px" className={styles.headerAcoes}>
              <Botao
                variant="primary"
                icon={mdiPlus}
                onClick={handleOpenModalNewObject}
              >
                Novo atalho
              </Botao>
            </HBox>
          </GridItem>
        </Grid>

        {/* Filtros */}
        <HBox>
          <CampoTexto
            value={search}
            onChange={setSearch}
            prepend={
              <Icon
                path={mdiMagnify}
                size={1}
                color="var(--tc-color-gray-500)"
              />
            }
            placeholder="Pesquisar"
          />
        </HBox>

        {queryList.isFetching && (
          <div>
            Aguarde...{' '}
            <Icon
              path={mdiLoading}
              size="14px"
              color="var(--tc-color-gray-700)"
              spin
            />
          </div>
        )}
        {!queryList.isFetching && (
          <div>
            Exibindo {queryFlatList?.length ?? '0'} de {total ?? '0'}{' '}
            resultados.
          </div>
        )}

        <DataTable
          isLoading={queryList.isFetching}
          cabecalhos={headers}
          linhas={queryFlatList ?? []}
          hasMoreData={queryList.hasNextPage}
          onLoadMore={async () => queryList.fetchNextPage()}
        />
      </VBox>
    </LayoutUsuario>
  );
};

export default Page;
